exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.space-bottom[data-v-406534a8] {\n  margin-bottom: 1em;\n}\n", "", {"version":3,"sources":["/home/runner/work/online-store/online-store/src/components/auth/LinkUser.vue"],"names":[],"mappings":";AAAA;EACE,mBAAmB;CAAE","file":"LinkUser.vue","sourcesContent":[".space-bottom {\n  margin-bottom: 1em; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-406534a8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/auth/LinkUser.vue
// module id = Nr5m
// module chunks = 18